import type { RatingCategory } from "@/types"
import { RatingItem } from "./RatingItem"
import { t } from "i18next"

export function RatingCategory({catId, categoryObject}: {catId: string, categoryObject: RatingCategory}) {
  return(
    <div>
      <h3>{t(`${catId}`)}</h3>
      <ul className="no-deco">
        {Object.keys(categoryObject).map((k,i)=> {
          return(
          <RatingItem 
            key={i}
            name={categoryObject[k].name}
            ratingNumber={categoryObject[k].ratingNumber}
            />
          )
        })}
      </ul>
    </div>
  )

}